const { getStorageDataForWhiteLabeling } = require("../services/white_label");

module.exports = Object.freeze({
  // baseUrl: "https://reaidynodejs2.azurewebsites.net/api", // azure production api
  baseUrl: process.env.REACT_APP_BASE_URL,
  // baseUrl: "https://hr-bot-nodejs-server-production.up.railway.app/api",
  testUrl: process.env.REACT_APP_TEST_URL,
  // testUrl: "https://9j2ddzhh-4000.inc1.devtunnels.ms/api",
  // testUrl: "http://10.10.3.136:4000/api",
  isTestServer: process.env.REACT_APP_IS_TEST_SERVER === "true",
  mainUrl: process.env.REACT_APP_IS_TEST_SERVER === "true" ? `${process.env.REACT_APP_TEST_URL}/api` : `${process.env.REACT_APP_BASE_URL}/api`,
  mainUrlPublic: process.env.REACT_APP_IS_TEST_SERVER === "true" ? `${process.env.REACT_APP_TEST_URL}/public` : `${process.env.REACT_APP_BASE_URL}/public`,

  enableBackUpAzureSpeechKey:
    process.env.REACT_APP_ENABLE_BACKUP_AZURE_SPEECH_KEY === "true",

  productionAzureSpeechKey: process.env.REACT_APP_AZURE_SPEECH_KEY,

  // backUpAzureSpeechKey: "a80edfa2fd0240d384a94e445106dca9",
  backUpAzureSpeechKey: process.env.REACT_APP_BACKUP_AZURE_SPEECH_KEY,

  enableAzureBackupForStorage:
    process.env.REACT_APP_ENABLE_AZURE_BACKUP_FOR_STORAGE === "true",

  // productionStorageData: [
  //   {
  //     tittle: "Ressume_storage",
  //     sasToken:
  //       "sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-03-20T18:29:00Z&sv=2022-11-02&sr=c&sig=p0SnVqsxx%2BY1xVbv5PSp8fEjQrJf%2Fh5z9QK7zc4fD1M%3D",
  //     sasUrl:
  //       "https://reaidystorage.blob.core.windows.net/resumes?sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-03-20T18:29:00Z&sv=2022-11-02&sr=c&sig=p0SnVqsxx%2BY1xVbv5PSp8fEjQrJf%2Fh5z9QK7zc4fD1M%3D",
  //     container: "resumes",
  //     expiryDate: "20-03-2025",
  //     accountName: "reaidystorage",
  //     actions: ["interview", "resume"],
  //   },
  //   // {
  //   //   tittle: "ScreenRecord_storage",
  //   //   sasToken: "sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
  //   //   sasUrl: "https://reaidystorage.blob.core.windows.net/screen-recordings?sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
  //   //   container: "screen-recodings",
  //   //   expiryDate: "20-03-2025",
  //   //   accountName: "reaidystorage",
  //   //   actions: ["recording"]
  //   // },
  //   {
  //     tittle: "Recordings_storage",
  //     sasToken:
  //       "sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-03-20T18:29:00Z&sv=2022-11-02&sr=c&sig=3MDtdX8TwummdnPUkzPpHK2JjMqpHLoXWG3mfsPxPhQ%3D",
  //     sasUrl:
  //       "https://reaidystorage.blob.core.windows.net/recordings?sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-03-20T18:29:00Z&sv=2022-11-02&sr=c&sig=3MDtdX8TwummdnPUkzPpHK2JjMqpHLoXWG3mfsPxPhQ%3D",
  //     container: "recordings",
  //     expiryDate: "20-03-2025",
  //     accountName: "reaidystorage",
  //     actions: ["recording"],
  //   },
  //   {
  //     tittle: "User-media_storage",
  //     sasToken:
  //       "sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-03-20T18:29:00Z&sv=2022-11-02&sr=c&sig=tlqtEu1HVhOSRqIw%2FE0btBesuAxCma9WdSE1%2BvNOuZg%3D",
  //     sasUrl:
  //       "https://reaidystorage.blob.core.windows.net/user-media?sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-03-20T18:29:00Z&sv=2022-11-02&sr=c&sig=tlqtEu1HVhOSRqIw%2FE0btBesuAxCma9WdSE1%2BvNOuZg%3D",
  //     container: "user-media",
  //     expiryDate: "20-03-2025",
  //     accountName: "reaidystorage",
  //     actions: ["profile", "user"],
  //   },
  // ],

  productionStorageData: getStorageDataForWhiteLabeling(),
  backUpStorageData: getStorageDataForWhiteLabeling(),

  // backUpStorageData: [
  //   {
  //     tittle: "Ressume_storage",
  //     sasToken:
  //       "sp=racwdli&st=2024-11-08T17:21:36Z&se=2025-11-08T01:21:36Z&sv=2022-11-02&sr=c&sig=ltDLabbjz1Q9lctDE1Jv6MMKr10vnZcUyQe3o%2Bu2XNo%3D",
  //     sasUrl:
  //       "https://jobfairreaidy.blob.core.windows.net/resumes?sp=racwdli&st=2024-11-08T17:21:36Z&se=2025-11-08T01:21:36Z&sv=2022-11-02&sr=c&sig=ltDLabbjz1Q9lctDE1Jv6MMKr10vnZcUyQe3o%2Bu2XNo%3D",
  //     container: "resumes",
  //     expiryDate: "09-11-2025",
  //     accountName: "jobfairreaidy",
  //     actions: ["interview", "resume"],
  //   },
  //   // {
  //   //   tittle: "ScreenRecord_storage",
  //   //   sasToken: "sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
  //   //   sasUrl: "https://reaidystorage.blob.core.windows.net/screen-recordings?sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
  //   //   container: "screen-recodings",
  //   //   expiryDate: "11-09-2025",
  //   //   accountName: "reaidystorage",
  //   //   actions: ["recording"]
  //   // },
  //   {
  //     tittle: "Recordings_storage",
  //     sasToken:
  //       "sp=racwdli&st=2024-11-08T17:18:21Z&se=2025-11-08T01:18:21Z&sv=2022-11-02&sr=c&sig=gLMHbcrdGgxGD%2FI72smC71ExeyRhGpaIRQ90GNGI6XA%3D",
  //     sasUrl:
  //       "https://jobfairreaidy.blob.core.windows.net/recordings?sp=racwdli&st=2024-11-08T17:18:21Z&se=2025-11-08T01:18:21Z&sv=2022-11-02&sr=c&sig=gLMHbcrdGgxGD%2FI72smC71ExeyRhGpaIRQ90GNGI6XA%3D",
  //     container: "recordings",
  //     expiryDate: "09-11-2025",
  //     accountName: "jobfairreaidy",
  //     actions: ["recording"],
  //   },
  //   {
  //     tittle: "User-media_storage",
  //     sasToken:
  //       "sp=racwdli&st=2024-11-08T17:24:04Z&se=2025-11-08T01:24:04Z&sv=2022-11-02&sr=c&sig=zaKBFpkrECOAG2hxE4f1Z9VJzF6iAaeD73rBV14AULM%3D",
  //     sasUrl:
  //       "https://jobfairreaidy.blob.core.windows.net/user-media?sp=racwdli&st=2024-11-08T17:24:04Z&se=2025-11-08T01:24:04Z&sv=2022-11-02&sr=c&sig=zaKBFpkrECOAG2hxE4f1Z9VJzF6iAaeD73rBV14AULM%3D",
  //     container: "user-media",
  //     expiryDate: "09-11-2025",
  //     accountName: "jobfairreaidy",
  //     actions: ["profile", "user"],
  //   },
  // ],
});
